import { Dialog as DialogWrapper } from 'cdk-radial';
import { DialogTypeProps } from './types';

export const Dialog = ({
  buttonsProps,
  title,
  handleClose,
  open,
  children: content,
  dataTestId,
  id,
  ...props
}: DialogTypeProps): React.JSX.Element => (
  <DialogWrapper
    buttonsProps={buttonsProps}
    onClose={handleClose}
    isOpen={open}
    title={title}
    dataTestId={dataTestId}
    id={id}
    {...props}
  >
    {content}
  </DialogWrapper>
);
